// extracted by mini-css-extract-plugin
export default {"LanguageSelect":"LanguageSelect_LanguageSelect__Hc588","flagIcon":"LanguageSelect_flagIcon__rL1LL"};